module.exports = __webpack_public_path__ + "img/ico-xls.de57ff5f.svg";